export const UtilityMixin = {
  methods: {
    getServerName() {
      //return 'IT'
      return 'COM'
    },

    getServerPostfix() {
      //return '.it'
      return '.com'
    },

    getApiServer() {
      //return 'https://www.apiconversion.sovecotech.com/api/index.php/'
      return 'https://www.sovecotech.com/sovtech/api/index3.php/'
      // return 'https://www.sovecotech.it/sovtech/api/index3.php/'
    },

    getKFTServer() {
      return 'https://s0.getposition.com/WebAPI/API/'
    },

    convertDateMysql(aDate) {
      let s = aDate.toLocaleString()
      return s
    },

    bitExtracted(number, k, p) {
      return ((1 << k) - 1) & (number >> (p - 1))
    },

    decodeAnalogs(item) {
      const vm = this
      let n1 = item.a1 / 16
      let n2 = item.a2 / 16
      let n3 = item.a3 / 16
      let analogs = {}

      analogs.date = item.date_rec
      analogs.values = []
      analogs.values.push(vm.bitExtracted(n1, 2, 7)) // status
      analogs.values.push(vm.bitExtracted(n2, 2, 7)) // overspeed

      analogs.values.push(vm.bitExtracted(n2, 2, 5)) // d1_card
      analogs.values.push(vm.bitExtracted(n1, 3, 1)) // d1_work
      analogs.values.push(vm.bitExtracted(n2, 4, 1)) // d1_times

      analogs.values.push(vm.bitExtracted(n3, 2, 5)) // d2_card
      analogs.values.push(vm.bitExtracted(n1, 3, 4)) // d2_work
      analogs.values.push(vm.bitExtracted(n3, 4, 1)) // d2_times
      return analogs
    },

    decodeAnalogsOld(storyData) {
      const vm = this
      let n1 = storyData.a1 / 16
      let n2 = storyData.a2 / 16
      let n3 = storyData.a3 / 16
      let analogs = {}

      analogs.date = storyData.date_rec
      analogs.status = vm.bitExtracted(n1, 2, 7)
      analogs.overspeed = vm.bitExtracted(n2, 2, 7)

      analogs.d1_card = vm.bitExtracted(n2, 2, 5)
      analogs.d1_work = vm.bitExtracted(n1, 3, 1)
      analogs.d1_times = vm.bitExtracted(n2, 4, 1)

      analogs.d2_card = vm.bitExtracted(n3, 2, 5)
      analogs.d2_work = vm.bitExtracted(n1, 3, 4)
      analogs.d2_times = vm.bitExtracted(n3, 4, 1)

      return analogs
    },

    findStringByStartingCharacters(arr, startingChars, key) {
      const sanitizedStartingChars = startingChars
        .replace(/\s+/g, '')
        .toUpperCase()

      return arr.filter((obj) => {
        if (
          typeof obj[key] === 'string' &&
          obj[key]
            .replace(/\s+/g, '')
            .toUpperCase()
            .startsWith(sanitizedStartingChars)
        ) {
          return true
        }

        return false
      })
    },

    newDate(aDate) {
      let d
      if (typeof aDate === 'string' || aDate instanceof String) {
        let newDate = aDate.replace(/-/g, '/')
        d = new Date(newDate)
      } else {
        d = new Date(aDate)
      }
      return d
    },

    currentDateSolo() {
      let today = new Date()
      let dd = today.getDate()

      let mm = today.getMonth() + 1

      let yyyy = today.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }
      return dd + '/' + mm + '/' + yyyy
    },

    plainDate(d) {
      let dd = ('0' + d.getDate()).slice(-2)
      let mm = ('0' + (d.getMonth() + 1)).slice(-2)
      let yy = d.getYear()
      return dd + '-' + mm + '-' + yy
    },

    plainDateTime(d) {
      let dd = ('0' + d.getDate()).slice(-2)
      let mm = ('0' + (d.getMonth() + 1)).slice(-2)
      let yy = ('' + d.getYear()).slice(-2)
      let hh = ('0' + d.getHours()).slice(-2)
      let mi = ('0' + d.getMinutes()).slice(-2)
      return dd + '-' + mm + '-' + yy + '  ' + hh + ':' + mi
    },

    currentDate() {
      let today = new Date()
      let dd = today.getDate()

      let mm = today.getMonth() + 1
      let hh = today.getHours()
      let mi = today.getMinutes()
      let yyyy = today.getFullYear()
      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }
      return dd + '/' + mm + '/' + yyyy + ' ' + hh + ':' + mi
    },

    isValidDate(d) {
      return d instanceof Date && !isNaN(d)
    },

    getMonday(d) {
      d = new Date(d)
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1) // adjust when day is sunday
      return new Date(d.setDate(diff))
    },

    getWeekFirstDay(s) {
      const vm = this
      let d = vm.getMonday(new Date(s))
      return d
    },

    isoLocalDate(s) {
      let tzoffset = new Date().getTimezoneOffset() * 60000 //offset in milliseconds
      let d

      if (s === null) {
        d = new Date()
      } else {
        d = this.newDate(s)
      }
      if (this.isValidDate(d)) {
        return new Date(d - tzoffset).toISOString().slice(0, -1)
      }
      return null
    },

    combineDateTime(d, t, m) {
      let d_date = this.newDate(d)
      let t_date = this.newDate(t)
      d_date.setHours(t_date.getHours())
      d_date.setMinutes(t_date.getMinutes())
      if (m > 0) {
        return d_date.toShowString()
      }
      return d_date.toMysqlString()
    },
    minToString(min) {
      let days = Math.trunc(min / 1440)
      let rest_d = min % 1440
      let hours = Math.trunc(rest_d / 60)
      let rest_h = Math.trunc(rest_d % 60)
      let s1 = min > 0 ? rest_h + ' m' : ''
      let s2 = hours > 0 || days > 0 ? hours + ' h ' : ''
      let s3 = days > 0 ? days + ' g ' : ''
      return s3 + s2 + s1
    },
    flattenBigdata(arr) {
      let flat = []
      for (let i = 0; i < arr.length; i++) {
        flat = flat.concat(arr[i].data)
      }
      return flat
    },
    checkTkn(data) {
      if (data.hasOwnProperty('error')) {
        if (data.error.text === 'NO AUTH') {
          return false
        } else {
          alert(data.text)
        }
        return false
      }
      return true
    },
    /*
		add_LatLng: function(data){
		  for (let i=0; i<data.length; i++){
				data[i].latlng= {lat:parseFloat(data[i].latitude), lng:parseFloat(data[i].longitude)}
			  }
		},*/
    moderateBounds(bounds, google) {
      // Don't zoom in too far on only one marker
      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        let extendPoint1 = new google.maps.LatLng(
          bounds.getNorthEast().lat() + 0.01,
          bounds.getNorthEast().lng() + 0.01
        )
        let extendPoint2 = new google.maps.LatLng(
          bounds.getNorthEast().lat() - 0.01,
          bounds.getNorthEast().lng() - 0.01
        )
        bounds.extend(extendPoint1)
        bounds.extend(extendPoint2)
      }
      return bounds
    },
    getPosBounds(pos, google) {
      let bounds = new google.maps.LatLngBounds()
      bounds.extend(pos)
      return this.moderateBounds(bounds, google)
    },
    getTripMapBounds(data, google) {
      let bounds = new google.maps.LatLngBounds()
      bounds.extend(
        new google.maps.LatLng(data.obj_s.latitude, data.obj_s.longitude)
      )
      bounds.extend(
        new google.maps.LatLng(data.obj_e.latitude, data.obj_e.longitude)
      )
      return this.moderateBounds(bounds, google)
    },
    getMapBounds(data, google) {
      let bounds = new google.maps.LatLngBounds()
      for (let i = 0; i < data.length; i++) {
        if (data[i].latitude > 0.01) {
          bounds.extend(
            new google.maps.LatLng(data[i].latitude, data[i].longitude)
          )
        }
      }
      return this.moderateBounds(bounds, google)
    },
    tripSortForDateAsc(a, b) {
      if (a.inizio < b.inizio) return -1
      if (a.inizio > b.inizio) return 1
      return 0
    },
    tripSortForDateDesc(a, b) {
      if (a.inizio < b.inizio) return 1
      if (a.inizio > b.inizio) return -1
      return 0
    },

    sortForDateAsc(a, b) {
      if (a.date < b.date) return -1
      if (a.date > b.date) return 1
      return 0
    },
    sortForDateDesc(a, b) {
      if (a.date < b.date) return 1
      if (a.date > b.date) return -1
      return 0
    },
    sortForTargaKeyAsc(a, b) {
      if (a.targaKey < b.targaKey) return -1
      if (a.targaKey > b.targaKey) return 1
      return 0
    },
    sortForTargaKeyDesc(a, b) {
      if (a.targaKey < b.targaKey) return 1
      if (a.targaKey > b.targaKey) return -1
      return 0
    },
    sortForTargaAsc(a, b) {
      if (a.targa < a.targa) return -1
      if (a.targa > b.targa) return 1
      return 0
    },
    sortForTargaDesc(a, b) {
      if (a.targa < b.targay) return 1
      if (a.targa > b.targa) return -1
      return 0
    },
    sortForDriverAsc(a, b) {
      if (a.nick < b.nick) return -1
      if (a.nick > b.nick) return 1
      return 0
    },
    sortForDriverDesc(a, b) {
      if (a.nick < b.nick) return 1
      if (a.nick > b.nick) return -1
      return 0
    },
    sortForModeAsc(a, b) {
      if (a.mode < b.mode) return -1
      if (a.mode > b.mode) return 1
      return 0
    },
    sortForModeDesc(a, b) {
      if (a.mode < b.mode) return 1
      if (a.mode > b.mode) return -1
      return 0
    },
    sortForGuidaAsc(a, b) {
      if (a.guida < b.guida) return -1
      if (a.guida > b.guida) return 1
      return 0
    },
    sortForGuidaDesc(a, b) {
      if (a.guida < b.guida) return 1
      if (a.guida > b.guida) return -1
      return 0
    },
    sortForPausaAsc(a, b) {
      if (a.pausa < b.pausa) return -1
      if (a.pausa > b.pausa) return 1
      return 0
    },
    sortForPausaDesc(a, b) {
      if (a.pausa < b.pausa) return 1
      if (a.pausa > b.pausa) return -1
      return 0
    },
    sortForKmAsc(a, b) {
      if (a.km < b.km) return -1
      if (a.km > b.km) return 1
      return 0
    },
    sortForKmDesc(a, b) {
      if (a.km < b.km) return 1
      if (a.km > b.km) return -1
      return 0
    },
    alphabetically(ascending) {
      return function (a, b) {
        if (a === null) {
          return 1
        } else if (b === null) {
          return -1
        } else if (a === b) {
          return 0
        } else if (ascending) {
          return a < b ? -1 : 1
        } else if (!ascending) {
          return a < b ? 1 : -1
        }
      }
    },
    isEmptyObject(obj) {
      return JSON.stringify(obj) === JSON.stringify({})
    },
    getSondaName(cod_sonda) {
      let s = ''
      switch (cod_sonda) {
        case 'C':
          s = 'CARBURANTE '
          break
        case 'T':
          s = 'TEMPERATURA '
          break
        case 'V':
          s = 'TEMPERATURA '
          break
      }
      return s
    },
    nullString(s) {
      if (s === null || s == 'undefined') {
        return ''
      } else {
        return s
      }
    },
    findSameObjInArray(aa, obj) {
      for (let i = 0; i < aa.length; i++) {
        if (aa[i] === obj) {
          return true
        }
      }
      return false
    },
    findObjInArray(aa, key, value) {
      for (let i = 0; i < aa.length; i++) {
        if (aa[i][key] === value) {
          return aa[i]
        }
      }
      return null
    },
    findObjIndexInArray(aa, key, value) {
      for (let i = 0; i < aa.length; i++) {
        if (aa[i][key] === value) {
          return i
        }
      }
      return -1
    },
    getDriverName(obj) {
      if (obj.cognome === null || typeof obj.cognome === 'undefined') {
        return ''
      } else {
        return obj.cognome + ' ' + obj.nome + ' ' + obj.nick
      }
    },
    getStatoMezzo(mode) {
      if (mode > 0) {
        return 'Fermo'
      } else {
        return 'In movimento'
      }
    },
    dateDiffDays(first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24))
    },
    diffMin(d1, d2) {
      return Math.abs(new Date(d1) - new Date(d2)) / (1000 * 60)
    },
    diffDateMin(d1, d2) {
      const diff = Math.abs(d1 - d2)
      return Math.floor(diff / 1000 / 60)
    },
    minuti2hour(mintot) {
      let hours = Math.trunc(mintot / 60)
      let min = mintot % 60
      return hours + 'h ' + min + 'm'
    },
    diffDateCalendarDay(d1, d2) {
      const vm = this
      let dd1 = new Date(d1)
      vm.zeroDate(dd1)
      let dd2 = new Date(d2)
      vm.zeroDate(dd2)
      return Math.round((dd2 - dd1) / (1000 * 60 * 60 * 24))
    },

    formatDate(date) {
      const yyyy = date.getFullYear()
      const mm = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-based
      const dd = String(date.getDate()).padStart(2, '0')
      return `${yyyy}${mm}${dd}`
    },

    reverseDateSolo(value) {
      if (!value) return ''
      let newValue = value.replace(/-/g, '/')
      return newValue.split('/').reverse().join('/')
    },
    reverseDateSoloSolo(value) {
      if (!value) return ''
      let newValue = value.replace(/-/g, '/')
      return newValue.split(' ')[0].split('/').reverse().join('/')
    },
    date2time(d) {
      let hh = ('0' + d.getHours()).slice(-2)
      let mm = ('0' + d.getMinutes()).slice(-2)
      let s = hh + ':' + mm
      return s
    },
    timeSolo(value) {
      if (!value) return ''
      return value.split(' ')[1]
    },
    reverseDate(value) {
      if (!value) return ''
      let newValue = value.replace(/-/g, '/')
      let dd = newValue.split(' ')
      return dd[0].split('/').reverse().join('/') + ' ' + dd[1]
    },
    addressSplitter(value, idx) {
      let a = value.split('|')

      if (idx == 0) {
        return a[0] + ' ' + a[1] + ' ' + a[2]
      } else {
        for (let i = 4; i < a.length; i++) {
          a[3] += ' '
          a[3] += a[i]
        }
        return a[3]
      }
    },
    isPosizioneOscurata(address, auth) {
      if (!auth || auth.tipo != 3) return false
      if (!auth.filtro_geografico_attivo || auth.filtro_geografico_attivo == 0) return false
      if (!auth.codici_postali || auth.codici_postali === '') return false
      if (!address || address === '') return true
      const capList = auth.codici_postali.split(',').map(c => c.trim())
      for (let i = 0; i < capList.length; i++) {
        if (address.indexOf('|' + capList[i] + '|') !== -1) return false
      }
      return true
    },
    applicaOscuramentoPosizioni(data, auth) {
      if (!auth || auth.tipo != 3) return data
      if (!auth.filtro_geografico_attivo || auth.filtro_geografico_attivo == 0) return data
      if (!auth.codici_postali || auth.codici_postali === '') return data
      for (let i = 0; i < data.length; i++) {
        if (this.isPosizioneOscurata(data[i].address, auth)) {
          data[i].oscurata = true
          data[i].address = ''
          data[i].latitude = 0
          data[i].longitude = 0
        } else {
          data[i].oscurata = false
        }
      }
      return data
    },
    zeroDate(d) {
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
    },
    endDate(d) {
      d.setHours(23)
      d.setMinutes(59)
      d.setSeconds(59)
    },
    deltaTime(d1, d2) {
      let date1 = this.newDate(d1).getTime()
      let date2 = this.newDate(d2).getTime()
      let diff = date1 - date2
      return diff
    },
    deltaTimeMin(d1, d2) {
      let date1 = this.newDate(d1).getTime() / 1000 / 60
      let date2 = this.newDate(d2).getTime() / 1000 / 60
      let diff = Math.round(date1 - date2)
      return diff
    },

    timeStr(diff) {
      let days = Math.trunc(diff / 86400000)
      let rest_d = diff % 86400000
      let hours = Math.trunc(rest_d / 3600000)
      let rest_h = rest_d % 3600000
      let min = Math.trunc(rest_h / 60000)
      let str = days + ' g ' + hours + ' h ' + min + ' m'
      return str
    },
    timeHourStr(diff) {
      let hours = Math.trunc(diff / 3600000)
      let rest_h = diff % 3600000
      let min = Math.trunc(rest_h / 60000)
      let str = hours + ' h ' + min + ' m'
      return str
    },

    calcDeltaTimeStr(d1, d2) {
      let vm = this
      let diff = vm.deltaTime(d1, d2)
      let days = Math.trunc(diff / 86400000)
      let rest_d = diff % 86400000
      let hours = Math.trunc(rest_d / 3600000)
      let rest_h = rest_d % 3600000
      let min = Math.trunc(rest_h / 60000)
      let str = days + ' g ' + hours + ' h ' + min + ' m'
      return str
    },
    calcDeltaTime(dd) {
      let date1 = new Date().getTime()
      let date2 = this.newDate(dd).getTime()
      let diff = date1 - date2
      let days = Math.trunc(diff / 86400000)
      let rest_d = diff % 86400000
      let hours = Math.trunc(rest_d / 3600000)
      let rest_h = rest_d % 3600000
      let min = Math.trunc(rest_h / 60000)
      return days + 'g ' + hours + 'h ' + min + 'm'
    },
    calcDeltaTimeSpecial(dd, tt) {
      let date1 = new Date().getTime()
      let date2 = this.newDate(dd).getTime()
      let date3 = this.newDate(tt).getTime()
      let diff = date1 - date2
      let diff2 = date1 - date3
      let days = Math.trunc(diff / 86400000)
      let rest_d = diff % 86400000
      let hours = Math.trunc(rest_d / 3600000)
      let rest_h = rest_d % 3600000
      let min = Math.trunc(rest_h / 60000)
      let modecolor = '2'
      let h = diff2 / 3600000
      if (h > 2 && h <= 24) {
        modecolor = '0'
      } else if (h <= 2) {
        modecolor = '1'
      }
      let result = { s: days + 'g ' + hours + 'h ' + min + 'm', m: modecolor }
      return result
    },

    calcPausaGuida(dd, mode) {
      let date1 = new Date().getTime()
      let date2 = this.newDate(dd).getTime()

      let diff = date1 - date2
      let days = Math.trunc(diff / 86400000)
      let rest_d = diff % 86400000
      let hours = Math.trunc(rest_d / 3600000)
      let rest_h = rest_d % 3600000
      let min = Math.trunc(rest_h / 60000)
      let pausa_guida
      if (mode == 0) {
        pausa_guida = 'Guida ' + days + ' g ' + hours + ' h ' + min + ' m'
      } else {
        pausa_guida = 'Pausa ' + days + ' g ' + hours + ' h ' + min + ' m'
      }
      return pausa_guida
    },

    extractCounter(counterObj, pos) {
      let numberPattern = /\d+/g
      let a = pos.message.match(numberPattern)
      if (a !== null) {
        counterObj.km += parseInt(a[0])
        counterObj.mn += parseInt(a[1])
      }
    },

    extractKmMessage(s) {
      let a
      let numberPattern = /\d+/g
      a = s.match(numberPattern)
      if (a) {
        return { km: parseInt(a[0]), mn: parseInt(a[1]) }
      }
      return null
    },

    extractKmMn(pos) {
      let counterObj = {
        km: 0,
        mn: 0,
      }
      let numberPattern = /\d+/g
      let a = pos.message.match(numberPattern)
      if (a !== null) {
        counterObj.km += parseInt(a[0])
        counterObj.mn += parseInt(a[1])
      } else {
        counterObj.km = 0
        counterObj.mn = 0
      }
      return counterObj
    },

    pollKmStart(poll_obj, counter_end, obj_stop) {
      const vm = this
      let km = 0
      if (poll_obj.date < obj_stop) {
        let counter_start = vm.extractKmMn(poll_obj)
        km = counter_end.km - counter_start.km
      }
      return km
    },
    pollKmEnd(poll_obj, counter_start, obj_start) {
      const vm = this
      let km = 0
      if (poll_obj.date > obj_start) {
        let counterEnd = vm.extractKmMn(poll_obj)
        km = counterEnd.km - counter_start.km
      }
      return km
    },

    calcJourneys(journeys) {
      //console.log('calcJourneys', journeys)
      const vm = this
      const kMinPausa = vm.prefs.sosta_min
      const kMaxPausa = vm.prefs.sosta_max
      // INSERISCE LE PAUSE
      const pauses = []
      for (let i = 0; i < journeys.length - 1; i++) {
        const minutes = vm.deltaTimeMin(
          journeys[i + 1].inizio,
          journeys[i].fine
        )
        if (minutes > kMinPausa) {
          pauses.push({
            tag: 0,
            type: 0,
            km: 0,
            minuti: minutes,
            fine: journeys[i + 1].inizio,
            idx_e: journeys[i + 1].idx_s,
            obj_e: journeys[i + 1].obj_s,
            inizio: journeys[i].fine,
            idx_s: journeys[i].idx_e,
            obj_s: journeys[i].obj_e,
          })
        }
      }

      const result = [...journeys, ...pauses]
      result.sort((a, b) => a.idx_s - b.idx_s)

      // CREA I GRUPPI
      let tag = 0
      for (let i = 0; i < result.length - 1; i++) {
        if (result[i].type === result[i + 1].type) {
          result[i + 1].tag = result[i].tag
        } else {
          tag++
          result[i + 1].tag = tag
        }
      }

      // COMPATTA
      const grouped = []
      for (let i = 0; i <= tag; i++) {
        const toCompact = result.filter((it) => it.tag === i)
        //console.log('toCompact', toCompact)
        const len = toCompact.length
        if (len > 1) {
          for (let x = 1; x < len; x++) {
            toCompact[0].km = toCompact[0].km + toCompact[x].km
          }
          toCompact[0].idx_e = toCompact[len - 1].idx_e
          toCompact[0].obj_e = toCompact[len - 1].obj_e
          toCompact[0].fine = toCompact[len - 1].fine
          toCompact[0].minuti = vm.deltaTimeMin(
            toCompact[len - 1].fine,
            toCompact[0].inizio
          )
          grouped.push(toCompact[0])
        } else if (len > 0) {
          grouped.push(toCompact[0])
        }
      }
      // CREA I GRUPPI VIAGGIO
      tag = 0
      for (let i = 0; i < grouped.length; i++) {
        if (grouped[i].type == 0 && grouped[i].minuti > kMaxPausa) {
          grouped[i].tag = -1
          tag++
        } else {
          grouped[i].tag = tag
        }
      }

      // CREA I VIAGGI
      const final = []
      let id = 0
      for (let i = 0; i <= tag; i++) {
        const realJourney = grouped.filter((it) => it.tag === i)
        const len = realJourney.length
        if (len > 1) {
          let km = 0
          for (let x = 0; x < len; x++) {
            km = km + realJourney[x].km
          }
          realJourney[0].km = km
          realJourney[0].idx_e = realJourney[len - 1].idx_e
          realJourney[0].obj_e = realJourney[len - 1].obj_e
          realJourney[0].fine = realJourney[len - 1].fine
          realJourney[0].tappe = grouped.filter(
            (it) => it.type === 0 && it.tag === i
          )
          realJourney[0].minuti = vm.deltaTimeMin(
            realJourney[len - 1].fine,
            realJourney[0].inizio
          )
          realJourney[0].id = id
          final.push(realJourney[0])
        } else {
          realJourney[0].id = id
          final.push(realJourney[0])
        }
        id++
      }

      return final
    },

    extractJourney(start, end, positions) {
      const vm = this
      const journeys = []
      //console.log('INIZIO')
      let journeyFlag = false
      let startIdx = 0
      let endIdx = -1
      let minuti = 0
      let km_stop = 0
      let km_start = 0

      positions.forEach((pos, idx) => {
        const isStart = pos.message.indexOf('START') >= 0
        const isCounter = pos.message.indexOf('COUNTER') >= 0
        const isTripStart = pos.message.indexOf('Trip Start') >= 0
        const isTripStop = pos.message.indexOf('Trip End') >= 0
        const isStop = pos.message.indexOf('STOP') >= 0 && isCounter
        const isUStop = pos.message.indexOf('STOP') >= 0 && !isCounter

        // rileva uno start con nessun viaggio in essere
        if ((isStart || isTripStart) && !journeyFlag) {
          //console.log('p0', idx, pos.message)
          journeyFlag = true
          startIdx = idx
          endIdx = idx
          if (isTripStart) {
            km_start = Math.round(parseInt(pos.message.split(':')[1]) / 10)
          } else {
            km_start = 0
          }
        }
        // rileva uno stop o uno start con viaggio in essere non concluso
        else if (isStop || isTripStop || (isStart && journeyFlag)) {
          //console.log('p1', idx, pos.message)
          if (isStart && journeyFlag) {
            console.log('isStart && journeyFlag')
            console.log(pos)
          }
          if (isTripStop) {
            //console.log('p1.1')
            endIdx = idx
            km_start = Math.round(
              parseInt(positions[startIdx].message.split(':')[1]) / 10
            )
            km_stop = Math.round(parseInt(pos.message.split(':')[1]) / 10)
            minuti = vm.diffMin(
              positions[endIdx].date,
              positions[startIdx].date
            )
          }
          if (isStop) {
            //console.log('p1.2')
            if (journeyFlag) {
              endIdx = idx
              const values = vm.extractKmMn(pos)
              km_stop = values.km
              minuti = values.mn
            } else {
              // stop privo di inizio non lo considero
              return
            }
          }

          if (endIdx > startIdx) {
            journeys.push({
              type: 1,
              tag: 0,
              km: km_stop - km_start,
              minuti: minuti,
              inizio: positions[startIdx].date,
              fine: positions[endIdx].date,
              idx_s: startIdx,
              idx_e: endIdx,
              obj_s: positions[startIdx],
              obj_e: positions[endIdx],
            })
            // console.log(
            //   'PUSH 1 - ',
            //   startIdx,
            //   endIdx,
            //   km_stop - km_start,
            //   minuti
            // )
            // console.log('PUSH 2 - ', pos.message)
            // console.log('PUSH 3 - journeyFlag ', journeyFlag)
          }
          journeyFlag = false

          if (isStart) {
            journeyFlag = true
            startIdx = idx
            endIdx = idx
            km_start = 0
            km_stop = 0
            minuti = 0
          }
        }

        //rileva un counter
        else if (isCounter && !isStop) {
          //console.log('p2', idx, pos.message)
          endIdx = idx
          const values = vm.extractKmMn(pos)
          km_stop = values.km
          minuti = values.mn
        }
      })

      console.log('JOURNEY ', journeys)
      let tt = 0
      for (let i = 0; i < journeys.length; i++) {
        tt = tt + journeys[i].km
      }
      console.log('TOT', tt)
      return journeys.length > 0 ? journeys : []
    },

    filterGuidaPausaBis(start, end, targa, positions) {
      const vm = this
      const journeys = vm.extractJourney(start, end, positions)
      const journal = []
      if (journeys.length === 0) {
        return []
      }
      let totKm = 0
      let entryGuida
      let entryPausa = {}
      entryPausa.targa = targa
      entryPausa.inizio = start.toLocaleMysqlString()
      entryPausa.fine = journeys[0].inizio
      entryPausa.delta = vm.deltaTime(entryPausa.fine, entryPausa.inizio)
      entryPausa.pausa = vm.timeStr(entryPausa.delta)
      entryPausa.isPausa = true
      journal.push(entryPausa)

      for (let i = 0; i < journeys.length - 1; i++) {
        entryGuida = {}
        entryGuida.targa = targa
        entryGuida.inizio = journeys[i].inizio
        entryGuida.fine = journeys[i].fine
        entryGuida.delta = vm.deltaTime(entryGuida.fine, entryGuida.inizio)
        entryGuida.guida = vm.timeStr(entryGuida.delta)
        entryGuida.isPausa = false
        entryGuida.km_guida = journeys[i].km
        entryGuida.mn_guida = journeys[i].minuti
        journal.push(entryGuida)
        entryPausa = {}
        entryPausa.targa = targa
        entryPausa.inizio = journeys[i].fine
        entryPausa.fine = journeys[i + 1].inizio
        entryPausa.delta = vm.deltaTime(entryPausa.fine, entryPausa.inizio)
        entryPausa.pausa = vm.timeStr(entryPausa.delta)
        entryPausa.isPausa = true
        journal.push(entryPausa)
      }
      entryGuida = {}
      entryGuida.targa = targa
      entryGuida.inizio = journeys[journeys.length - 1].inizio
      entryGuida.fine = journeys[journeys.length - 1].fine
      entryGuida.delta = vm.deltaTime(entryGuida.fine, entryGuida.inizio)
      entryGuida.guida = vm.timeStr(entryGuida.delta)
      entryGuida.isPausa = false
      entryGuida.km_guida = journeys[journeys.length - 1].km
      entryGuida.mn_guida = journeys[journeys.length - 1].minuti
      journal.push(entryGuida)

      entryPausa = {}
      entryPausa.targa = targa
      entryPausa.inizio = journeys[journeys.length - 1].fine
      entryPausa.fine = end.toLocaleMysqlString()
      entryPausa.delta = vm.deltaTime(entryPausa.fine, entryPausa.inizio)
      entryPausa.pausa = vm.timeStr(entryPausa.delta)
      entryPausa.isPausa = true
      journal.push(entryPausa)
      // console.log('journal', journal)
      return journal
    },
    /*
    filterGuidaPausa(start, end, targa, poss) {
      const vm = this
      let i
      let isStart = -1
      let isStop = -1
      let isCounter = -1
      let isTripStart = false
      let isTripStop = false
      let km_start = 0
      let km_stop = 0

      let entryGuida = null
      let entryPausa = null

      let counterObj = {
        km: 0,
        mn: 0,
      }
      let deltaMin = 0
      let newPoss = []
      let mode = 0 // 0 = stop e start chiusi  1 = start aperto  2 = stop aperto

      const kMinDelta = vm.prefs.sosta_min

      for (i = 0; i < poss.length; i++) {
        isStart = poss[i].message.indexOf('START') >= 0
        isTripStart = poss[i].message.indexOf('Trip Start') >= 0
        isTripStop = poss[i].message.indexOf('Trip End') >= 0
        isStop =
          poss[i].message.indexOf('STOP') >= 0 &&
          poss[i].message.indexOf('COUNTER') >= 0
        isCounter =
          poss[i].message.indexOf('COUNTER') >= 0 &&
          !poss[i].message.indexOf('STOP') >= 0

        // START
        if (isStart || isTripStart) {
          if (isTripStart) {
            km_start = parseInt(poss[i].message.split(':')[1])
          }
          switch (mode) {
            case 0: // UNDEFINED
              entryPausa = {}
              entryPausa.targa = targa
              entryPausa.inizio = start //start.toLocaleMysqlString()
              entryPausa.fine = poss[i].date
              entryPausa.delta = vm.deltaTime(
                entryPausa.fine,
                entryPausa.inizio
              )
              entryPausa.pausa = vm.timeStr(entryPausa.delta)
              entryPausa.isPausa = true
              newPoss.push(entryPausa) // pausa

              entryGuida = {}
              entryGuida.targa = targa
              entryGuida.inizio = poss[i].date
              entryGuida.fine = ''
              entryGuida.guida = ''
              entryGuida.pausa = ''
              entryGuida.km_guida = ''
              entryGuida.mn_guida = ''
              counterObj = {
                km: 0,
                mn: 0,
              }
              entryGuida.isPausa = false
              mode = 1
              break //

            case 1: // START APERTO
              break // start open quindi il nuovo start viene ignorato

            case 2: // STOP APERTO
              entryPausa.fine = poss[i].date
              entryPausa.delta = vm.deltaTime(
                entryPausa.fine,
                entryPausa.inizio
              )
              entryPausa.pausa = vm.timeStr(entryPausa.delta)
              entryPausa.isPausa = true
              newPoss.push(entryPausa)
              entryGuida = {}
              entryGuida.targa = targa
              entryGuida.inizio = poss[i].date
              entryGuida.fine = ''
              entryGuida.guida = ''
              entryGuida.pausa = ''
              entryGuida.mn_guida = ''
              entryGuida.km_guida = ''
              entryGuida.isPausa = false
              counterObj = {
                km: 0,
                mn: 0,
              }
              mode = 1

              break
          }
        }

        // STOP

        if (isStop || isTripStop) {
          if (isTripStop) {
            km_stop = parseInt(poss[i].message.split(':')[1])
          }
          switch (mode) {
            case 0: // UNDEFINED
              entryGuida = {}
              entryGuida.targa = targa
              entryGuida.inizio = start //start.toLocaleMysqlString()
              entryGuida.fine = poss[i].date
              entryGuida.delta = vm.deltaTime(
                entryGuida.fine,
                entryGuida.inizio
              )
              entryGuida.guida = vm.timeStr(entryGuida.delta)
              entryGuida.isPausa = false
              if (isTripStop) {
                entryGuida.km_guida = Math.trunc((km_stop - km_start) / 10)
                entryGuida.mn_guida = vm.diffMin(
                  entryGuida.fine,
                  entryGuida.inizio
                )
              } else {
                vm.extractCounter(counterObj, poss[i])
                entryGuida.km_guida = counterObj.km
                entryGuida.mn_guida = counterObj.mn
              }
              newPoss.push(entryGuida)
              entryPausa = {}
              entryPausa.targa = targa
              entryPausa.inizio = poss[i].date
              mode = 2
              break
            case 1: // START APERTO
              entryGuida.fine = poss[i].date
              entryGuida.delta = vm.deltaTime(
                entryGuida.fine,
                entryGuida.inizio
              )
              entryGuida.guida = vm.timeStr(entryGuida.delta)
              entryGuida.isPausa = false
              if (isTripStop) {
                entryGuida.km_guida = Math.trunc((km_stop - km_start) / 10)
                entryGuida.mn_guida = vm.diffMin(
                  entryGuida.fine,
                  entryGuida.inizio
                )
              } else {
                vm.extractCounter(counterObj, poss[i])
                entryGuida.km_guida = counterObj.km
                entryGuida.mn_guida = counterObj.mn
              }
              newPoss.push(entryGuida)
              entryPausa = {}
              entryPausa.targa = targa
              entryPausa.inizio = poss[i].date
              mode = 2

              break
            case 2: // STOP APERTO
              break
          }
        }
      }
      return newPoss
    },
*/
    /*


		filterGuidaPausa: function(start,end,poss) {
			  const vm=this
			  let i
			  let isStart
			  let isStop
			  let isCounter

			  let entryGuida = null
			  let entryPausa = null

			  let counterObj={km:0,mn:0}
			  let deltaMin = 0
			  let newPoss = []
			  let mode = 0; // 0 = stop e start chiusi  1 = start aperto  2 = stop aperto


			  const kMinDelta = vm.$root.prefs.sosta_min

			  for (i = 0; i < poss.length; i++) {

				/*isStart = poss[i].message.indexOf("START")
				isStop = poss[i].message.indexOf("STOP")
				isCounter = poss[i].message.indexOf("COUNTER")
				*/
    /*
				isStart   = poss[i].message.indexOf("START") >= 0
				isStop    = poss[i].message.indexOf("STOP") >= 0 && poss[i].message.indexOf("COUNTER") >= 0
				isCounter = poss[i].message.indexOf("COUNTER") >= 0 && !poss[i].message.indexOf("STOP") >= 0

		// START
				if(isStart >= 0) {

				  switch(mode) {
					 case 0:  // UNDEFINED
					  entryPausa = {}
					  entryPausa.inizio = start //start.toLocaleMysqlString()
					  entryPausa.fine=poss[i].date
					  entryPausa.delta = vm.deltaTime(entryPausa.fine,entryPausa.inizio)
					  entryPausa.pausa = vm.timeStr(entryPausa.delta)
					  entryPausa.isPausa = true
					  newPoss.push(entryPausa)  // pausa


					  entryGuida = {}
					  entryGuida.inizio = poss[i].date
					  entryGuida.fine = ""
					  entryGuida.guida= ""
					  entryGuida.pausa= ""
					  entryGuida.km_guida=""
					  counterObj={km:0,mn:0}
					  entryGuida.isPausa=false

					  mode = 1
					  break; //

					case 1:  // START APERTO
					  break; // start open quindi il nuovo start viene ignorato

					case 2:  // STOP APERTO

					  deltaMin = this.diffMin(poss[i].date, entryPausa.inizio)
					  if(deltaMin < kMinDelta) {
						mode = 1
						entryPausa=null
					  } else
					  {
						  entryPausa.fine = poss[i].date
						  entryPausa.delta = vm.deltaTime(entryPausa.fine,entryPausa.inizio)
						  entryPausa.pausa = vm.timeStr(entryPausa.delta)
						  entryPausa.isPausa=true
						  newPoss.push(entryPausa)
						entryGuida = {}
						entryGuida.inizio = poss[i].date
						entryGuida.fine = ""
						entryGuida.guida= ""
						entryGuida.pausa= ""
						entryGuida.km_guida=""
						entryGuida.isPausa=false
						counterObj={km:0,mn:0}
						mode = 1
					  }
					  break;
				  }
				}

		  // STOP

				if (isCounter >= 0) {
				  switch(mode) {
					case 0:  // UNDEFINED
					  entryGuida = {}
					  entryGuida.inizio = start //start.toLocaleMysqlString()
					  entryGuida.fine = poss[i].date
					  entryGuida.delta = vm.deltaTime(entryGuida.fine,entryGuida.inizio)
					  entryGuida.guida = vm.timeStr(entryGuida.delta)
					  entryGuida.isPausa = false
					  vm.extractCounter(counterObj,poss[i])
					  entryGuida.km_guida=counterObj.km
					  newPoss.push(entryGuida)
					  entryPausa = {}
					  entryPausa.inizio = poss[i].date
					  mode = 2
					  break;
					case 1:  // START APERTO
					  entryGuida.fine = poss[i].date
					  entryGuida.delta = vm.deltaTime(entryGuida.fine,entryGuida.inizio)
					   entryGuida.guida = vm.timeStr(entryGuida.delta)
					   entryGuida.isPausa = false
					  vm.extractCounter(counterObj,poss[i])
					  entryGuida.km_guida=counterObj.km

					  if (!vm.findSameObjInArray(newPoss,entryGuida))
					  {
					  newPoss.push(entryGuida)
					  }
					  entryPausa = {}
					  entryPausa.inizio = poss[i].date
					  mode = 2

					  break;
				   case 2: // STOP APERTO
				   break;
				}
			  }
			  }
			  return newPoss
			},
		*/

    /*
    findStop(idx, poss) {
      let entry_idx = -1
      for (let i = idx; i < poss.length; i++) {
        if (poss[i].message.indexOf('START')) {
          break
        }
        if (
          poss[i].message.indexOf('STOP') &&
          poss[i].message.indexOf('COUNTER')
        ) {
          entry_idx = i
          break
        }
      }
      return entry_idx
    },

    extractDaysStats(vobj, start, end, poss) {
      const vm = this
      if (poss.length < 1) return
      let o_day = poss[0].date.substring(0, 10)
      let n_day
      let idx_s, idx_e
      let stats = []
      let temp
      let mode = 0
      let start_obj, end_obj
      idx_s = 0
      for (let i = 0; i < poss.length; i++) {
        if (poss[i].message.indexOf('START')) {
          start_obj = poss[i]
          mode = 1
        }
        if (
          poss[i].message.indexOf('STOP') &&
          poss[i].message.indexOf('COUNTER')
        ) {
          end_obj == poss[i]
          mode = 2
        }
        n_day = poss[i].date.substring(0, 10)
        // giorno finisce con nessun viaggio
        if (n_day !== o_day && mode == 0) {
          stats.push([])
        }
        // giorno finisce con uno stop
        if (n_day !== o_day && mode == 2) {
          idx_e = i
          temp = vm.extract_single_day(poss, idx_s, idx_e, false)
          stats.push(temp)
          o_day = n_day
          idx_s = i
        }
        // giorno finisce con uno start
        if (n_day !== o_day && mode == 1) {
          console.log('Giorno finisce con uno start')
        }
      }
    },
 
    extractSingleDay(poss, i_start, i_end) {
      const vm = this
      let i
      let isStart
      let isStop
      let isCounter
      let start = this.newDate(poss[i_start].date)
      start.setHours(0)
      start.setMinutes(0)
      start.setSeconds(0)
      let end = this.newDate(poss[i_start].date)
      end.setHours(23)
      end.setMinutes(59)
      end.setSeconds(59)

      let entryGuida = null
      let entryPausa = null

      let counterObj = {
        km: 0,
        mn: 0,
      }
      let deltaMin = 0
      let newPoss = []
      let mode = 0 // 0 = stop e start chiusi  1 = start aperto  2 = stop aperto

      const kMinDelta = 10

      for (i = i_start; i < i_end; i++) {
        isStart = poss[i].message.indexOf('START')
        isStop = poss[i].message.indexOf('STOP')
        isCounter = poss[i].message.indexOf('COUNTER')

        // START
        if (isStart >= 0) {
          switch (mode) {
            case 0: // UNDEFINED
              entryPausa = {}
              entryPausa.inizio = start.toLocaleMysqlString()
              entryPausa.fine = poss[i].date
              entryPausa.delta = vm.deltaTime(
                entryPausa.fine,
                entryPausa.inizio
              )
              entryPausa.pausa = vm.timeStr(entryPausa.delta)
              entryPausa.isPausa = true
              newPoss.push(entryPausa) // pausa

              entryGuida = {}
              entryGuida.inizio = poss[i].date
              entryGuida.fine = ''
              entryGuida.guida = ''
              entryGuida.pausa = ''
              entryGuida.km_guida = ''
              counterObj = {
                km: 0,
                mn: 0,
              }
              entryGuida.isPausa = false

              mode = 1
              break //

            case 1: // START APERTO
              break // start open quindi il nuovo start viene ignorato

            case 2: // STOP APERTO
              deltaMin = this.diffMin(poss[i].date, entryPausa.inizio)
              if (deltaMin < kMinDelta) {
                mode = 1
                entryPausa = null
              } else {
                entryPausa.fine = poss[i].date
                entryPausa.delta = vm.deltaTime(
                  entryPausa.fine,
                  entryPausa.inizio
                )
                entryPausa.pausa = vm.timeStr(entryPausa.delta)
                entryPausa.isPausa = true
                newPoss.push(entryPausa)
                entryGuida = {}
                entryGuida.inizio = poss[i].date
                entryGuida.fine = ''
                entryGuida.guida = ''
                entryGuida.pausa = ''
                entryGuida.km_guida = ''
                entryGuida.isPausa = false
                counterObj = {
                  km: 0,
                  mn: 0,
                }
                mode = 1
              }
              break
          }
        }

        // STOP

        if (isCounter >= 0) {
          switch (mode) {
            case 0: // UNDEFINED
              entryGuida = {}
              entryGuida.inizio = start.toLocaleMysqlString()
              entryGuida.fine = poss[i].date
              entryGuida.delta = vm.deltaTime(
                entryGuida.fine,
                entryGuida.inizio
              )
              entryGuida.guida = vm.timeStr(entryGuida.delta)
              entryGuida.isPausa = false
              vm.extractCounter(counterObj, poss[i])
              entryGuida.km_guida = counterObj.km
              newPoss.push(entryGuida)
              entryPausa = {}
              entryPausa.inizio = poss[i].date
              mode = 2
              break
            case 1: // START APERTO
              entryGuida.fine = poss[i].date
              entryGuida.delta = vm.deltaTime(
                entryGuida.fine,
                entryGuida.inizio
              )
              entryGuida.guida = vm.timeStr(entryGuida.delta)
              entryGuida.isPausa = false
              vm.extractCounter(counterObj, poss[i])
              entryGuida.km_guida = counterObj.km

              if (!vm.findSameObjInArray(newPoss, entryGuida)) {
                newPoss.push(entryGuida)
              }
              entryPausa = {}
              entryPausa.inizio = poss[i].date
              mode = 2

              break
            case 2: // STOP APERTO
              break
          }
        }
      }
      if (mode == 1) {
        entryGuida.fine = end.toLocaleMysqlString()
        entryGuida.delta = vm.deltaTime(entryGuida.fine, entryGuida.inizio)
        entryGuida.isPausa = false
        entryGuida.km_guida = 0
        newPoss.push(entryGuida)
      }
      if (mode == 2) {
        entryPausa.fine = end.toLocaleMysqlString()
        entryPausa.delta = vm.deltaTime(entryPausa.fine, entryPausa.inizio)
        entryPausa.pausa = vm.timeStr(entryPausa.delta)
        entryPausa.isPausa = true
        newPoss.push(entryPausa)
      }

      return newPoss
    },
*/
    filterSommarioGuidaPausa(start, end, targa, poss) {
      const vm = this

      let newposs = vm.filterGuidaPausaBis(start, end, targa, poss)
      let entry = {}

      entry.targa = targa
      entry.guida = ''
      entry.pausa = ''
      entry.km = 0

      let guida = 0
      let pausa = 0
      let viaggi = 0
      let km = 0
      let entries = []
      for (let i = 0; i < newposs.length; i++) {
        if (newposs[i].isPausa === true) {
          pausa += newposs[i].delta
        } else {
          guida += newposs[i].delta
          km += newposs[i].km_guida
          viaggi++
        }
      }
      entry.viaggi = viaggi
      entry.pausa = pausa
      entry.guida = guida
      entry.guida_str = vm.timeStr(guida)
      entry.pausa_str = vm.timeStr(pausa)
      entry.km = km
      return entry
    },
    /*
    filterTripPause(poss) {
      const vm = this
      let i
      let isStart
      let isStop
      let isCounter
      let startIndex
      let stopIndex
      let startObj = null
      let stopObj = null
      let startPauseObj = null
      let counterObj = {
        km: 0,
        mn: 0,
      }
      let deltaMin = 0
      let newPoss = []
      let mode = 0 // 0 = stop e start chiusi  1 = start aperto  2 = stop aperto
      const kMinDelta = 10
      for (i = 0; i < poss.length; i++) {
        isStart = poss[i].message.indexOf('START')
        isStop = poss[i].message.indexOf('STOP')
        isCounter = poss[i].message.indexOf('COUNTER')
        if (isStart >= 0) {
          switch (mode) {
            case 0:
              if (startPauseObj) {
                startPauseObj.stopDate = poss[i].date
                startPauseObj.pausa = vm.calcDeltaTimeStr(
                  startPauseObj.stopDate,
                  startPauseObj.date
                )
                startPauseObj.isPause = true
                newPoss.push(startPauseObj)
              }
              startObj = poss[i]
              startObj.isPause = false
              startIndex = i
              mode = 1
              break // nulla
            case 1:
              break // start open quindi il nuovo start viene ignorato
            case 2:
              deltaMin = this.diffMin(poss[i].date, stopObj.date)
              if (deltaMin < kMinDelta) {
                mode = 1
                stopObj = null
              } else {
                startObj.guida = vm.calcDeltaTimeStr(
                  stopObj.date,
                  startObj.date
                )
                startObj.stopObj = stopObj
                startObj.stopDate = stopObj.date
                startObj.counterObj = counterObj
                startObj.km_guida = counterObj.km
                startObj.startIndex = startIndex
                startObj.stopIndex = stopIndex
                newPoss.push(startObj)
                startObj = poss[i]
                startObj.isPause = false
                counterObj = {
                  km: 0,
                  mn: 0,
                }
                startIndex = i
                mode = 1
                if (startPauseObj) {
                  startPauseObj.stopDate = poss[i].date
                  startPauseObj.pausa = vm.calcDeltaTimeStr(
                    startPauseObj.stopDate,
                    startPauseObj.date
                  )
                  startPauseObj.isPause = true
                  newPoss.push(startPauseObj)
                }
              }
              break
          }
        }
        if (isStop >= 0) {
          switch (mode) {
            case 0:
              break
            case 1:
            case 2:
              startPauseObj = poss[i]
              startPauseObj.isPause = true
              stopObj = poss[i]
              if (isCounter) {
                vm.extractCounter(counterObj, poss[i])
              }
              stopIndex = i
              mode = 2
              break
          }
        }
      }
      if (mode == 2) {
        startObj.guida = vm.calcDeltaTimeStr(stopObj.date, startObj.date)
        startObj.stopObj = stopObj
        startObj.stopDate = stopObj.date
        startObj.counterObj = counterObj
        startObj.km_guida = counterObj.km
        startObj.startIndex = startIndex
        startObj.stopIndex = stopIndex
        newPoss.push(startObj)
      }
      return newPoss
    },
  
    filterTrip(poss) {
      const vm = this
      let i
      let isStart
      let isStop
      let isCounter
      let startIndex
      let stopIndex
      let startObj = null
      let stopObj = null
      let counterObj = {
        km: 0,
        mn: 0,
      }
      let deltaMin = 0
      let newPoss = []
      let mode = 0 // 0 = stop e start chiusi  1 = start aperto  2 = stop aperto
      const kMinDelta = 10
      for (i = 0; i < poss.length; i++) {
        isStart = poss[i].message.indexOf('START')
        isStop = poss[i].message.indexOf('STOP')
        isCounter = poss[i].message.indexOf('COUNTER')
        if (isStart >= 0) {
          switch (mode) {
            case 0:
              startObj = poss[i]
              startIndex = i
              mode = 1
              break // nulla
            case 1:
              break // start open quindi il nuovo start viene ignorato
            case 2:
              deltaMin = this.diffMin(poss[i].date, stopObj.date)
              if (deltaMin < kMinDelta) {
                mode = 1
                stopObj = null
              } else {
                startObj.stopObj = stopObj
                startObj.counterObj = counterObj
                startObj.startIndex = startIndex
                startObj.stopIndex = stopIndex
                newPoss.push(startObj)
                startObj = poss[i]
                counterObj = {
                  km: 0,
                  mn: 0,
                }
                startIndex = i
                mode = 1
              }
              break
          }
        }
        if (isStop >= 0) {
          switch (mode) {
            case 0:
              break
            case 1:
            case 2:
              stopObj = poss[i]
              if (isCounter) {
                vm.extractCounter(counterObj, poss[i])
              }
              stopIndex = i
              mode = 2
              break
          }
        }
      }
      if (mode == 2) {
        startObj.stopObj = stopObj
        startObj.counterObj = counterObj
        startObj.startIndex = startIndex
        startObj.stopIndex = stopIndex
        newPoss.push(startObj)
      }
      return newPoss
    },
    */

    movingAverage(data, windowSize) {
      const smoothedData = []
      const halfWindow = Math.floor(windowSize / 2)

      for (let i = 0; i < data.length; i++) {
        let sum = 0
        let count = 0

        for (let j = -halfWindow; j <= halfWindow; j++) {
          const index = i + j
          if (index >= 0 && index < data.length) {
            sum += data[index]
            count++
          }
        }

        smoothedData.push(sum / count)
      }

      return smoothedData
    },

    movingAverageObj(data, windowSize) {
      const smoothedData = []
      const halfWindow = Math.floor(windowSize / 2)

      for (let i = 0; i < data.length; i++) {
        let sum = 0
        let count = 0

        for (let j = -halfWindow; j <= halfWindow; j++) {
          const index = i + j
          if (index >= 0 && index < data.length) {
            sum += data[index].v0
            count++
          }
        }
        data[i].v0 = sum / count
        smoothedData.push(sum / count)
      }

      return smoothedData
    },

    smoth(data, windowSize) {
      const halfWindow = Math.floor(windowSize / 2)
      return data.map((it, i) => {
        let sum = 0
        let count = 0

        for (let j = -halfWindow; j <= halfWindow; j++) {
          const index = i + j
          if (index >= 0 && index < data.length) {
            sum += data[index].v0
            count++
          }
        }
        return { ...it, v0: sum / count }
      })
    },

    // Converts from degrees to radians.
    toRadians(degrees) {
      return (degrees * Math.PI) / 180
    },

    // Converts from radians to degrees.
    toDegrees(radians) {
      return (radians * 180) / Math.PI
    },

    bearing(startLat, startLng, destLat, destLng) {
      const vm = this
      startLat = vm.toRadians(startLat)
      startLng = vm.toRadians(startLng)
      destLat = vm.toRadians(destLat)
      destLng = vm.toRadians(destLng)

      let y = Math.sin(destLng - startLng) * Math.cos(destLat)
      let x =
        Math.cos(startLat) * Math.sin(destLat) -
        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng)
      let brng = Math.atan2(y, x)
      brng = vm.toDegrees(brng)
      return (brng + 360) % 360
    },

    guessSonde34(element, succ, prev) {
      const vm = this
      if (prev) {
        if (prev.message.length > 0) {
          prev.delta = 1000
        } else {
          prev.delta = Math.abs(vm.diffMin(element.date, prev.date) * 60)
        }
      }
      if (succ) {
        if (succ.message.length > 0) {
          succ.delta = 1000
        } else {
          succ.delta = Math.abs(vm.diffMin(succ.date, element.date) * 60)
        }
      }
      if (succ && prev) {
        if (succ.delta < prev.delta) {
          element.v3 = succ.v3
          element.v4 = succ.v4
        } else {
          element.v3 = prev.v3
          element.v4 = prev.v4
        }
      } else {
        if (prev == null) {
          if (succ) {
            element.v3 = succ.v3
            element.v4 = succ.v4
          }
        }
        if (succ == null) {
          if (prev) {
            element.v3 = prev.v3
            element.v4 = prev.v4
          }
        }
      }
    },

    calcHeading(list) {
      const vm = this
      const pi34 = (Math.PI * 3) / 4
      let x, y, t
      for (let i = 0; i < list.length - 1; i++) {
        let element = list[i]

        if (element.message.length > 0) {
          let prev = i > 0 ? list[i - 1] : null
          let succ = i < list.length - 1 ? list[i + 1] : null
          vm.guessSonde34(element, succ, prev)
        }

        list[i].direction = Math.floor(
          vm.bearing(
            list[i].latitude,
            list[i].longitude,
            list[i + 1].latitude,
            list[i + 1].longitude
          )
        )

        t = 450 - list[i].direction
        if (t > 360) {
          t = t - 360
        }
        t = vm.toRadians(t)
        list[i].x = Math.cos(t)
        list[i].y = Math.sin(t)
        list[i].x1 = Math.cos(t + pi34)
        list[i].y1 = Math.sin(t + pi34)
        list[i].x2 = Math.cos(t - pi34)
        list[i].y2 = Math.sin(t - pi34)
      }
    },
    createIcon(m, z, google) {
      const vm = this
      let icon = {}

      let size = '' + z * 1.6
      let svg = ''
      switch (m.poi_type + '') {
        case '1':
          svg =
            'data:image/svg+xml;utf-8, <svg width="' +
            size +
            '" height="' +
            size +
            '" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"> <path fill="xxx" stroke="black" stroke-width="1.5" d="M3.5 3.5h25v25h-25z" ></path> </svg>'
          break
        case '2':
          svg =
            'data:image/svg+xml;utf-8, <svg width="' +
            size +
            '" height="' +
            size +
            '" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"> <path fill="xxx" stroke="black" stroke-width="1.5" d="M16 1L30 28H-1Z" ></path>  </svg>'
          break
        case '3':
          svg =
            'data:image/svg+xml;utf-8, <svg width="' +
            size +
            '" height="' +
            size +
            '" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"> <circle  cx="16" cy="16" r="14" fill="xxx" stroke="black" stroke-width="1.5"/> </svg>'
          break
      }
      icon.anchor = new google.maps.Point(z * 1.6, z * 1.6)
      let tmp = svg.replace('xxx', m.poi_color)
      icon.url = tmp.replace('#', '%23')
      icon.size = new google.maps.Size(z * 1.6, z * 1.6)
      return icon
    },
    hasSondeCarb(obj) {
      return (
        obj.sonda_1 == 'C' ||
        obj.sonda_2 == 'C' ||
        obj.sonda_3 == 'C' ||
        obj.sonda_4 == 'C'
      )
    },
    getSvgIcon(mode, targa, prefs) {
      let vm = this
      let colorMode
      let colorText
      let mySvg
      let s_mode = '' + mode
      if (mode >= 3 && mode < 24) {
        s_mode = '3'
      }
      switch (s_mode) {
        case '0': // movimento
          colorMode = prefs.bcg0
          colorText = prefs.ttt0
          break
        case '1': // stop <= 1 ora
          colorMode = prefs.bcg1
          colorText = prefs.ttt1
          break
        case '2': // stop <=2 ore
          colorMode = prefs.bcg2
          colorText = prefs.ttt2
          break
        case '3': // stop <= 3
          colorMode = prefs.bcg3
          colorText = prefs.ttt3
          break
        default:
          // fermo > 3 ore
          colorMode = prefs.bcg4
          colorText = prefs.ttt4
          break
      }
      mySvg =
        'data:image/svg+xml;utf-8,' +
        '<svg width="55" height="61" viewBox="0 0 55 61" xmlns="http://www.w3.org/2000/svg"> \
				<polyline points="1,33  54,33  54,50 35,50 30,60 25,50 1,50 1,33" style="stroke:' +
        encodeURIComponent(colorMode) +
        '; stroke-width: 2; fill: ' +
        encodeURIComponent(colorMode) +
        ';"/><text x="4" y="45" fill="' +
        encodeURIComponent(colorText) +
        '" font-size="10">' +
        targa +
        '</text></svg>'

      return mySvg
    },
    getOrientedSvg(m, isSelected) {
      let color = isSelected ? 'rgb(255,0,0)' : 'rgb(0,128,255)'
      let xx = 1
      let yy = 1
      let xx1 = 1
      let yy1 = 1
      let xx2 = 1
      let yy2 = 1
      if (m.x !== undefined && m.y !== undefined) {
        xx = Math.round((8 + m.x * 8) * 100) / 100
        yy = Math.round((8 - m.y * 8) * 100) / 100
        xx1 = Math.round((8 + m.x1 * 8) * 100) / 100
        yy1 = Math.round((8 - m.y1 * 8) * 100) / 100
        xx2 = Math.round((8 + m.x2 * 8) * 100) / 100
        yy2 = Math.round((8 - m.y2 * 8) * 100) / 100
      }
      let mySvg =
        'data:image/svg+xml;utf-8,\
					  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">\
					  <path style="stroke:rgb(1,0,0); stroke-width:1; fill:' +
        color +
        ';" d="M' +
        xx +
        ',' +
        yy +
        'L' +
        xx1 +
        ',' +
        yy1 +
        'L' +
        xx2 +
        ',' +
        yy2 +
        'z"/></svg>'
      return mySvg
    },
    getStartEndSvg(myString, isSelected) {
      let color = isSelected ? 'rgb(255,0,0)' : 'rgb(51,204,51)'
      let dd = myString.split(' ')
      let ddd = dd[0]
      let newValue = ddd.replace(/-/g, '/')
      let res = newValue.split('/').reverse().join('/')
      let mySvg =
        'data:image/svg+xml;utf-8, \
			<svg width="55" height="61" viewBox="0 0 55 61" xmlns="http://www.w3.org/2000/svg"> \
			<polyline points="1,22  54,22  54,50 35,50 30,60 25,50 1,50 1,22" style="stroke:black; stroke-width: 2; fill: ' +
        color +
        ';"/>\
			 <text x="4" y="45" fill="black"  font-size="10">' +
        dd[1] +
        '</text> <text x="4" y="34" fill="black"  font-size="10">' +
        res +
        '</text></svg>'
      return mySvg
    },
  },
}

//SELECT date,message FROM `position` where cod='1323' and date>='2022-10-14 06:51:00' and date<'2022-10-14 16:01:00' and message like '%COUNTER%'
